<template>
  <div>
    <b-row class="mb-3">
      <b-col xl="12" lg="12" order-xl="1" order-lg="2" order-md="2" order-sm="2" order="2" >
        <div class="card m-auto" style="max-width: 1236px;" >
          <div class="card-body">
            <div class="rounded overflow-hidden position-relative" style="width: 100%; max-height: 20em;">
              <img class="img-fluid" src="https://ik.imagekit.io/s4ldoeur60/8767770.jpg" />
            </div>
            <div class="d-flex flex-column flex-sm-row">
              <div class="text-center pl-4 pr-5 flex-shrink-0" :class="$style.user" style="margin-top: -6em;">
                <div
                  class="kit__utils__avatar kit__utils__avatar--rounded kit__utils__avatar--sizeProfile border border-5 border-white d-inline-block"
                >
                  <b-img left style="width:100%;"
                    :src="`${student.pathAvatar}`"
                    @error="event => event.target.src = 'https://ik.imagekit.io/czqsnlwbh2e/users/avatars/user-placeholder_LxKtaNY341.webp'"
                    shape="circle" fluid alt="Fluid image" />
                </div>
                <div class="font-size-16 font-weight-bold">{{ student.names + ' ' + student.lastNames }}</div>
              </div>
              <div v-show="projects.length" class="mr-auto mt-auto">
                <a-tabs v-model="tabActive" :activeKey="tabActive">
                  <a-tab-pane tab="Información académica" :key="1" />
                </a-tabs>
              </div>
            </div>
          </div>
        </div>
      </b-col>
    </b-row>
    <b-row v-show="projects.length">
      <b-col>
        <div class="card m-auto pb-4" style="max-width: 600px;">
          <div class="card-body pt-3 pb-0">
            <b-row class="mb-3">
              <b-col>
                <b>Lista de proyectos</b>
              </b-col>
            </b-row>
            <b-card v-for="(project, index) in projects" :key="index" no-body class="m-auto border-0">
              <b-row>
                <b-col cols="1" sm="1" md="1" lg="1">
                  <b-button block v-b-toggle="'collapsable'+index" variant="link" class="m-auto text-left">
                    <!-- <i class="fa fa-angle-double-down text-right" /> -->
                    <i :class=" collapseList[index] ? 'fa fa-angle-double-up text-right' : 'fa fa-angle-double-down text-right'" />
                  </b-button>
                </b-col>
                <b-col cols="10" sm="17" md="18" lg="18" xl="18" class="p-0">
                  <b-button block v-b-toggle="'collapsable'+index" variant="link" class="m-auto text-left">
                    {{ project.title }}
                  </b-button>
                </b-col>
              </b-row>
              <b-row>
                <b-col cols="1" sm="1" md="1" lg="1" />
                <b-col cols="9" sm="10" md="11" lg="11" xl="11" class="">
                  <b-collapse
                    :id="'collapsable'+index"
                    :accordion="'collapse'"
                    v-model="collapseList[index]"
                    role="tabpanel"
                    class="mt-2 pr-2"
                  >
                  <b-row class="m-auto" v-if="project.resume !== null">
                    <b>Resumen:</b>
                  </b-row>
                  <b-row class="m-auto pb-3" v-if="project.resume !== null">
                    {{ project.resume }}
                  </b-row>
                  <b-row class="m-auto" v-if="project.objectives !== null">
                    <b>Objetivos:</b>
                  </b-row>
                  <b-row class="m-auto pb-3" v-if="project.objectives !== null">
                    {{ project.objectives }}
                  </b-row>
                  <b-row class="m-auto" v-if="project.finishedProduct !== null">
                    <b>Producto entregado:</b>
                  </b-row>
                  <b-row class="m-auto pb-3" v-if="project.finishedProduct !== null">
                    {{ project.finishedProduct }}
                  </b-row>
                  <b-row class="m-auto" v-if="project.achievedImpact !== null">
                    <b>Impacto obtenido:</b>
                  </b-row>
                  <b-row class="m-auto pb-3" v-if="project.achievedImpact !== null">
                    {{ project.achievedImpact }}
                  </b-row>
                  </b-collapse>
                </b-col>
              </b-row>
            </b-card>
          </div>
        </div>
      </b-col>
    </b-row>
  </div>
</template>
<script>
import apiClient from '@/services/axios'
import { mapState } from 'vuex'
import axios from 'axios'
// import Swal from 'sweetalert2'

export default {
  name: 'accountsProfile',
  data() {
    return {
      tabActive: 1,
      student: {
        name: '',
        lastName: '',
      },
      projects: [],
      collapseList: [],
    }
  },
  computed: {
    ...mapState(['user']),
  },
  beforeRouteEnter (to, from, next) {
    function getStudentInfo() {
      return apiClient.get('/academic-projects')
    }
    axios.all([getStudentInfo()])
      .then(axios.spread(function (studentInfo) {
        next((vm) => {
          vm.setStudentInfo(null, studentInfo.data)
        })
      }))
      .catch(err => {
        next((vm) => {
          vm.setStudentInfo(err, [])
        })
      })
  },
  methods: {
    setStudentInfo (err, data) { // Carga la informacion del beforeRouteEnter
      if (err) {
        this.error = err.toString()
      } else {
        this.projects = data.projects
        this.student = data.user
        this.student.names = this.student.names.toLowerCase().replace(/(^|\s)\S/g, (l) => l.toUpperCase())
        this.student.lastNames = this.student.lastNames.toLowerCase().replace(/(^|\s)\S/g, (l) => l.toUpperCase())
        this.student.pathAvatar += '?tr=w-500,h-530,fo-auto/tr:r-max'
        if (data.projects.length > 0) {
          for (let i = 0; i < this.projects.length; i++) {
            this.collapseList.push(false)
          }
        }
      }
    },
  },
}
</script>
<style lang="scss" module>
@import "./style.module.scss";
</style>
